import React from 'react';
import { FMFullWidthBannerProps } from '../../types/fm-full-width-banner';
import FMButton from '../fm-button/fm-button';
import './fm-full-width-banner.scss';
const FMFullWidthBanner = ({
    imageHeight,
    imageWidth,
    imageLoading = 'eager',
    imageDecoding = 'auto',
    imageStyles = {},
    imageFetchPriority,
    ...props
}: FMFullWidthBannerProps) => {
    return (
        <div className='fm-full-width-banner'>
            {props.title && (
                <div className={'fm-full-width-banner__title'}>
                    {props.title}
                </div>
            )}
            <img
                src={props.imgPath}
                alt={props.imgAlt}
                className={'fm-full-width-banner__image'}
                loading={imageLoading}
                decoding={imageDecoding}
                {...(imageFetchPriority
                    ? ({
                          fetchpriority: imageFetchPriority,
                      } as any)
                    : {})}
                style={{
                    ...imageStyles,
                }}
                {...(imageHeight ? { height: imageHeight } : {})}
                {...(imageWidth ? { width: imageWidth } : {})}
            />
            <div className={'fm-full-width-banner__body-container'}>
                {props.subCopy && (
                    <div className={'fm-full-width-banner__subcopy'}>
                        {props.subCopy}
                    </div>
                )}
                {props.button && props.button.label && (
                    <div className='fm-full-width-banner__button'>
                        <FMButton
                            type={props.button.type}
                            label={props.button.label}
                            chevron={props.button.chevron}
                            disabled={props.button.disabled}
                            onClick={props.button.onClick}
                            preventDefault={props.button.preventDefault}
                            href={props.button.href}
                            target={props.button.target}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
export default FMFullWidthBanner;
